module.exports = __webpack_public_path__ + "static/media/add-grey.22b39a56.svg";